export const clipBoardFunc = 0;
export const httpFunc = 0;